/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {TemplateQuantitativeDriverDTO} from './TemplateQuantitativeDriverDTO';

/**
 * The ChecklistTemplateQuantitativeDriverDTO model module.
 * @module model/ChecklistTemplateQuantitativeDriverDTO
 * @version v0
 */
export class ChecklistTemplateQuantitativeDriverDTO {
  /**
   * Constructs a new <code>ChecklistTemplateQuantitativeDriverDTO</code>.
   * @alias module:model/ChecklistTemplateQuantitativeDriverDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistTemplateQuantitativeDriverDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistTemplateQuantitativeDriverDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistTemplateQuantitativeDriverDTO} The populated <code>ChecklistTemplateQuantitativeDriverDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistTemplateQuantitativeDriverDTO();
      if (data.hasOwnProperty('templateQuantitativeDriverId'))
        obj.templateQuantitativeDriverId = ApiClient.convertToType(data['templateQuantitativeDriverId'], 'Number');
      if (data.hasOwnProperty('templateQuantitativeDriver'))
        obj.templateQuantitativeDriver = TemplateQuantitativeDriverDTO.constructFromObject(data['templateQuantitativeDriver']);
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('weight'))
        obj.weight = ApiClient.convertToType(data['weight'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} templateQuantitativeDriverId
 */
ChecklistTemplateQuantitativeDriverDTO.prototype.templateQuantitativeDriverId = undefined;

/**
 * @member {module:model/TemplateQuantitativeDriverDTO} templateQuantitativeDriver
 */
ChecklistTemplateQuantitativeDriverDTO.prototype.templateQuantitativeDriver = undefined;

/**
 * @member {Boolean} enabled
 */
ChecklistTemplateQuantitativeDriverDTO.prototype.enabled = undefined;

/**
 * @member {Number} weight
 */
ChecklistTemplateQuantitativeDriverDTO.prototype.weight = undefined;

